import CookiePolicyRoute from './cookie-policy.route';
import CookiePolicyLocale from './cookie-policy.locale';

angular.module('BTMS')
.config(CookiePolicyRoute)
.config(CookiePolicyLocale);



/** WEBPACK FOOTER **
 ** ./client/public/main/cookie-policy/index.js
 **/